export const IconLockUnblock20: {
  name: 'icon_lock_unblock_20-d6daa1306315'
} = {
  name: 'icon_lock_unblock_20-d6daa1306315'
}
